import { Grid } from '@mui/material';
import React from 'react';

import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(({ palette, ...theme }) => ({
    mensagem1: {
        color: 'var(--GreenSuccess)',
        fontWeight: 'bold',
        fontSize: '24px',
        lineHeight: '32px',
        
    },
    mensagem2: {
        marginTop: '24px',
        color: 'var(--BlackTwo)',
        fontWeight: 'normal',
        fontSize: '16px',
        lineHeight: '24px',
        paddingBottom: '32px'
    },
}))

export default function CadastroAnuncianteForm4({ email, nomeResponsavel, sobrenome, cargo, cpf, telefoneResponsavel, handleChange }) {

    const classes = useStyles()

    return (
        <Grid item lg={12} md={12} sm={12} xs={12}>
            <div className={classes.mensagem1}>
                Seu cadastro foi finalizado com sucesso!
            </div>
            <div className={classes.mensagem2}>
                Iremos validar o seu cadastro e em breve te enviaremos um email com todas as informações necessárias para que você possa acessar a área do Anunciante no Site <b>Assista Mais</b>.
            </div>
        </Grid>
    );
}

